import { render, staticRenderFns } from "./subid.vue?vue&type=template&id=f128e63e&lang=pug&"
import script from "./subid.vue?vue&type=script&lang=js&"
export * from "./subid.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("C:\\git\\front\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('f128e63e')) {
      api.createRecord('f128e63e', component.options)
    } else {
      api.reload('f128e63e', component.options)
    }
    module.hot.accept("./subid.vue?vue&type=template&id=f128e63e&lang=pug&", function () {
      api.rerender('f128e63e', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/sample/sample/id/subid.vue"
export default component.exports